import { useGetStoryblokBundle } from "./useBundle"
import { useGetStoryblokProduct } from "./useProduct"

/* Both branches are identical by design: the discriminant must be narrowed for
 * the object to satisfy Product | Bundle, which a single branch cannot do.
 */
export const storyblokItemFromConfig = (
  uuid: string,
  config: Storyblok.ProductConfig | Storyblok.BundleConfig
): Storyblok.Product | Storyblok.Bundle =>
  config.component === "product"
    ? { _uid: "", component: config.component, uuid, content: config }
    : { _uid: "", component: config.component, uuid, content: config }

export const useGetStoryblokItem = () => {
  const getStoryBlokProduct = useGetStoryblokProduct()
  const getStoryBlokBundle = useGetStoryblokBundle()

  /* The below check is to handle recommendedProducts that were not automatically
   * resolved (This occurs when there are too many nested relations coming through on a single page)
   * into correct type Storyblok.Bundle | Storyblok.Product
   */
  const getStoryblokItem = (
    item: string | Storyblok.Product | Storyblok.Bundle
  ) => {
    let storyblokItem: Storyblok.ProductConfig | Storyblok.BundleConfig | null =
      null

    const itemId = typeof item === "string" ? item : item.uuid

    if (typeof item !== "string") {
      return { content: item.content, id: itemId }
    }

    storyblokItem = getStoryBlokProduct(itemId)

    if (!storyblokItem) {
      storyblokItem = getStoryBlokBundle(itemId)
    }

    return { content: storyblokItem, id: itemId }
  }

  return getStoryblokItem
}
